export default __webpack_public_path__ + "static/media/pulse.e9b454c9.png";